import { jsx as o } from "react/jsx-runtime";
import { createPortal as e } from "react-dom";
import { observer as t } from "mobx-react-lite";
import { Loader as i } from "./chunk163.js";
const s = t(({ store: r }) => e(
  /* @__PURE__ */ o("aside", { children: /* @__PURE__ */ o(i, { show: r.isLoading }) }),
  document.body
));
export {
  s as MainLoader
};
